import gql from 'graphql-tag';

export default gql`
query getProjectPreviewSlug($projectId: Int!) {
  projects_by_pk(project_id: $projectId) {
    project_id
    preview_slug
  }
}
`;
